import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App.jsx";

import $ from "jquery";


import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "react-notifications-component/dist/theme.css";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "font-awesome/css/font-awesome.min.css";


import { AuthProvider } from "./Store/AuthContext.jsx";
import { Provider } from "react-redux";
import { store } from "./Store/store.js";
// import ErrorBoundary from "./ErrorBoundary.jsx";

window.$ = $;
window.jQuery = $;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(

  //  <React.StrictMode>
    <Provider store={store}>
      <AuthProvider>
        <App />
      </AuthProvider>
   </Provider>
  // </React.StrictMode>
 
  
);
